import {
  CheckCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import { UploadedReceiptStatus } from '../../../types';

interface ReactionStatusBadgeProps {
  status: UploadedReceiptStatus | undefined;
}

const ReactionStatusBadge: React.FC<ReactionStatusBadgeProps> = ({ status }) => {
  if (!status) return null;

  if (status === 'imported') {
    return (
      <div className='mt-1 text-xs'>
        <span className='text-green-600 flex items-center gap-1'>
          <CheckCircleIcon className='w-4 h-4' />
          Booking imported
        </span>
      </div>
    );
  }

  if (status === 'import-failed') {
    return (
      <div className='mt-1 text-xs'>
        <span className='text-red-600 flex items-center gap-1'>
          <XCircleIcon className='w-4 h-4' />
          Import failed
        </span>
      </div>
    );
  }

  return null;
};

export default ReactionStatusBadge;
